export var EVALUATION_STORAGE_KEYS;
(function (EVALUATION_STORAGE_KEYS) {
  EVALUATION_STORAGE_KEYS["VALUATION_USER_VALUES"] = "valuationUserValues";
  EVALUATION_STORAGE_KEYS["VALUATION_PREDICTED_PRICE"] = "valuationPredictedPrice";
  EVALUATION_STORAGE_KEYS["APPOINTMENT_DETAILS"] = "appointment-details";
  EVALUATION_STORAGE_KEYS["VALUATION_DATA_VALUES"] = " valuationDataValues";
})(EVALUATION_STORAGE_KEYS || (EVALUATION_STORAGE_KEYS = {}));
export var SELLER_STATE_COOKIE = 'EVAL_ST';
export var BUYER_EVAL_STATE = 'B_EVAL_ST';
export var REPEAT_USER_COOKIE_NAME = 'IRU';
export var USER_INTENT_COOKIE = 'U_INT';
export var USER_TAB_COOKIE = 'U_TAB';
export var LAST_SELECTED_SECTION = 'lastSelectedSection';
export var EVALUATION_STATES;
(function (EVALUATION_STATES) {
  EVALUATION_STATES["INITIAL"] = "INITIAL";
  EVALUATION_STATES["VALUATION_STARTED"] = "VALUATION_STARTED";
  EVALUATION_STATES["CALLBACK_REQUESTED"] = "CALLBACK_REQUESTED";
  EVALUATION_STATES["VALUATION_ERROR"] = "VALUATION_ERROR";
  EVALUATION_STATES["VALUATION_DONE"] = "VALUATION_DONE";
  EVALUATION_STATES["APPOINTMENT_CREATED"] = "APPOINTMENT_CREATED";
  EVALUATION_STATES["BRAND_SELECTED"] = "BRAND_SELECTED";
  EVALUATION_STATES["VEHICLE_AGE_SELECTED"] = "VEHICLE_AGE_SELECTED";
  EVALUATION_STATES["BODY_TYPE_SELECTED"] = "BODY_TYPE_SELECTED";
  EVALUATION_STATES["VALUATION_BEYOND_LIMIT"] = "VALUATION_BEYOND_LIMIT";
  EVALUATION_STATES["USI_SUCCESS"] = "USI_SUCCESS";
  EVALUATION_STATES["USI_ERROR"] = "USI_ERROR";
  EVALUATION_STATES["USI_NOQUOTE"] = "USI_NOQUOTE";
  EVALUATION_STATES["VALUATION_ATTRIBUTE_SELECT"] = "valuation_attribute_select";
  EVALUATION_STATES["SELL_HOME_WIDGET_SHOWN"] = "sell_home_widget_shown";
  EVALUATION_STATES["VALUATION_PAGE_OPEN"] = "valuation_page_open";
})(EVALUATION_STATES || (EVALUATION_STATES = {}));
export var EVALUATION_STATES_TRACKING;
(function (EVALUATION_STATES_TRACKING) {
  EVALUATION_STATES_TRACKING["VALUATION_COMPLETE"] = "valuation_complete";
  EVALUATION_STATES_TRACKING["APPOINTMENT_CREATED"] = "appointment_created";
  EVALUATION_STATES_TRACKING["CALLBACK_COMPLETE"] = "call_back_complete";
  EVALUATION_STATES_TRACKING["VALUATION_REVISED"] = "valuation_revised";
  EVALUATION_STATES_TRACKING["AI_COMPLETED"] = "ai_completed";
  EVALUATION_STATES_TRACKING["BOOKING_CONFIRMATION"] = "booking_confirmation_return";
})(EVALUATION_STATES_TRACKING || (EVALUATION_STATES_TRACKING = {}));
export var USER_VISIT_STATUS;
(function (USER_VISIT_STATUS) {
  USER_VISIT_STATUS[USER_VISIT_STATUS["FIRST_TIME"] = 1] = "FIRST_TIME";
  USER_VISIT_STATUS[USER_VISIT_STATUS["REPEAT"] = 2] = "REPEAT";
})(USER_VISIT_STATUS || (USER_VISIT_STATUS = {}));
export var USER_VISIT_STATUS_LAYOUT;
(function (USER_VISIT_STATUS_LAYOUT) {
  USER_VISIT_STATUS_LAYOUT["FIRST_TIME"] = "first_time";
  USER_VISIT_STATUS_LAYOUT["REPEAT"] = "repeat";
})(USER_VISIT_STATUS_LAYOUT || (USER_VISIT_STATUS_LAYOUT = {}));
export var USER_INTENT;
(function (USER_INTENT) {
  USER_INTENT["SELLER"] = "seller";
  USER_INTENT["BUYER"] = "buyer";
  USER_INTENT["FINANCE"] = "finance";
})(USER_INTENT || (USER_INTENT = {}));
export var TAB_NAME;
(function (TAB_NAME) {
  TAB_NAME["BUY"] = "BUY";
  TAB_NAME["SELL"] = "SELL";
  TAB_NAME["FINANCE"] = "FINANCE";
  TAB_NAME["INITIAL"] = "";
})(TAB_NAME || (TAB_NAME = {}));
export var FLOW_TYPES;
(function (FLOW_TYPES) {
  FLOW_TYPES["NO_DRAFT"] = "instant_sell_new_booking_no_draft";
  FLOW_TYPES["RESCHEDULE"] = "instant_sell_reschedule_booking";
})(FLOW_TYPES || (FLOW_TYPES = {}));
export var FIELD_NAMES;
(function (FIELD_NAMES) {
  FIELD_NAMES["SELF_INSPECT"] = "self_inspect";
  FIELD_NAMES["GO_TO_HOME"] = "go_to_home";
})(FIELD_NAMES || (FIELD_NAMES = {}));
export default {
  USER_VISIT_STATUS: USER_VISIT_STATUS,
  USER_VISIT_STATUS_LAYOUT: USER_VISIT_STATUS_LAYOUT,
  EVALUATION_STATES: EVALUATION_STATES,
  REPEAT_USER_COOKIE_NAME: REPEAT_USER_COOKIE_NAME,
  SELLER_STATE_COOKIE: SELLER_STATE_COOKIE,
  EVALUATION_STORAGE_KEYS: EVALUATION_STORAGE_KEYS,
  USER_INTENT: USER_INTENT,
  USER_INTENT_COOKIE: USER_INTENT_COOKIE,
  LAST_SELECTED_SECTION: LAST_SELECTED_SECTION,
  TAB_NAME: TAB_NAME,
  USER_TAB_COOKIE: USER_TAB_COOKIE,
  BUYER_EVAL_STATE: BUYER_EVAL_STATE
};
export var EVALUATION_ROUTES;
(function (EVALUATION_ROUTES) {
  EVALUATION_ROUTES["VALUATION_FLOW"] = "/valuation-flow";
  EVALUATION_ROUTES["SELF_INSPECTION"] = "/self-inspection";
})(EVALUATION_ROUTES || (EVALUATION_ROUTES = {}));
export var USI = 'usi';